import { combineReducers } from 'redux';
import { reducer as reduxForms } from 'redux-form';
import form from './form/form';
import application from './application/application';

export default combineReducers({
  application,
  customForm: form,
  form: reduxForms
});
